import { useEffect, useState } from "react";
import React from 'react';
import Api from "../../Api/Api";
import { username } from "../../API";

import NavBar from "../Navbar";

const TermCondition = () => {
  const [user, setUser] = useState(null);
  const [configData, setConfigData] = useState(false);
  // const { username } = useParams();
  useEffect(() => {
    const getData = async () => {
      const { data } = await Api.getConfigText(username);
      for (let i = 0; i < data?.length; i++) {
        if (data[i].title === "Terms and Conditions") {
          setConfigData(data[i]);
        }
      }
    };
    getData();
  }, [username]);

  // console.log(JSON.parse(JSON.stringify(configData?.Text)));

  return (
    <>
      <NavBar />
      <div className="container bg-light rounded mx-auto min-vh-100 mb-3 mt-5" style={{ marginTop: "16%" }}>
        <div className="mt-3 ms-3">

          <h2 className="pt-3 text-center">Terms And Conditions</h2>
          <div className="pb-4 mt-3" dangerouslySetInnerHTML={{ __html: configData?.Text }}></div>
        </div>
      </div>
    </>
  );
};
export default TermCondition;
